import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const modules = {
  toolbar: [
    [{ 'header': [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'color': [] }, { 'background': [] }],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'align': [] }],
    [{ 'direction': 'rtl' }],
    ['link', 'image', 'video'],
    ['blockquote', 'code-block'],
    [{ 'indent': '-1'}, { 'indent': '+1' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],
    ['clean']
  ],
  clipboard: {
    matchVisual: false
  }
};

const formats = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'list', 'bullet',
  'align', 'direction',
  'link', 'image', 'video',
  'blockquote', 'code-block',
  'indent',
  'script'
];

export const RichTextEditor = ({ value, onChange, placeholder }: RichTextEditorProps) => {
  return (
    <div className="border rounded-lg overflow-hidden bg-background min-h-[400px]" dir="rtl">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        className="font-arabic ql-editor-rtl h-[350px]"
      />
    </div>
  );
};